import React from 'react';
import { motion } from 'framer-motion';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import LockIcon from '@mui/icons-material/Lock';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import CreditCardIcon from '@mui/icons-material/CreditCard';
export function Hero() {
  const bullets = ['Sin experiencia previa', 'Sin local ni máquinas', 'Desde tu casa', 'Con acceso inmediato'];
  return <section className="pt-3 pb-5 px-4 overflow-hidden relative bg-brand-50" style={{
    backgroundImage: "linear-gradient(rgba(250, 245, 255, 0.75), rgba(250, 245, 255, 0.85)), url('https://cdn.magicpatterns.com/uploads/jGP2JcxSha2uJbhLLViYn9/ChatGPT_Image_26_may_2026,_14_00_58.png')",
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat'
  }} data-id="element-130">
      <div className="max-w-3xl mx-auto flex flex-col items-center text-center gap-2 relative z-10" data-id="element-131">
        <motion.div initial={{
        opacity: 0,
        y: -10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.4
      }} className="inline-flex items-center gap-2 bg-brand-100 text-brand-800 px-3 py-1 rounded-full font-semibold text-xs" data-id="element-132">
          🐾 PATITAS EMPRENDEDORAS™
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="sm:text-3xl lg:text-4xl font-extrabold text-slate-900 text-[22px]" data-id="element-133">
          Convertí Tu Amor Por Las Mascotas En Un{' '}
          <span className="text-brand-700" data-id="element-134">Negocio Rentable</span> Hecho Con Tus
          Propias Manos
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} className="relative w-full max-w-[280px] sm:max-w-[340px] mt-2" data-id="element-135">
          <div className="relative z-10 rounded-xl overflow-hidden shadow-lg border-2 border-white" data-id="element-136">
            <img src="https://cdn.magicpatterns.com/uploads/pufQiRNon6R1NsFR51hppz/ChatGPT_Image_26_may_2026,_13_10_18.png" alt="Patitas Emprendedoras Book Mockup" className="w-full h-auto object-cover" data-id="element-137" />
          </div>

          {/* Floating Badges */}
          <motion.div initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.6
        }} className="absolute -bottom-2 -left-3 sm:-bottom-3 sm:-left-4 bg-white px-2 py-1 rounded-lg shadow-md border border-slate-100 flex items-center gap-1.5 z-20" data-id="element-138">
            <div className="bg-yellow-100 p-1 rounded-full text-yellow-600 text-xs" data-id="element-139">
              ⭐
            </div>
            <div className="text-left" data-id="element-140">
              <p className="font-bold text-slate-900 text-xs leading-tight" data-id="element-141">
                4.9/5
              </p>
              <p className="text-[9px] text-slate-500 leading-tight" data-id="element-142">
                Calificación
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: -10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.8
        }} className="absolute -top-2 -right-3 sm:-top-3 sm:-right-4 bg-white px-2 py-1 rounded-lg shadow-md border border-slate-100 flex items-center gap-1.5 z-20" data-id="element-143">
            <div className="bg-green-100 p-1 rounded-full text-green-600 text-xs" data-id="element-144">
              📈
            </div>
            <div className="text-left" data-id="element-145">
              <p className="font-bold text-slate-900 text-xs leading-tight" data-id="element-146">
                +500 personas
              </p>
              <p className="text-[9px] text-slate-500 leading-tight" data-id="element-147">
                Ya empezaron
              </p>
            </div>
          </motion.div>
        </motion.div>

        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.3
      }} className="sm:text-base font-medium max-w-2xl mt-2 text-[12px] text-[#121214] leading-snug" data-id="element-148">
          El método más simple para empezar un emprendimiento desde casa creando
          accesorios artesanales para mascotas en Argentina.
        </motion.p>

        <div className="flex flex-wrap items-center justify-center mt-1 gap-x-3 gap-y-0.5" data-id="element-149">
          {bullets.map((bullet, idx) => <div key={idx} className="flex items-center gap-1 text-slate-700 font-medium text-xs sm:text-sm" data-id="element-150">
              <CheckCircleIcon className="text-brand-600" sx={{
            fontSize: 14
          }} data-id="element-151" />
              <span data-id="element-152">{bullet}</span>
            </div>)}
        </div>

        <motion.button initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.4
      }} onClick={() => {
        const target = document.getElementById('pricing-card');
        if (!target) return;
        const stickyOffset = 40; // height of sticky countdown bar
        const top = target.getBoundingClientRect().top + window.scrollY - stickyOffset;
        window.scrollTo({
          top,
          behavior: 'smooth'
        });
      }} className="bg-brand-600 hover:bg-brand-700 text-white text-base sm:text-lg font-bold py-3 px-6 rounded-xl shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-1 w-full sm:w-auto flex items-center justify-center gap-2 mt-2" data-id="element-153">
          🐾 QUIERO EMPEZAR MI NEGOCIO HOY
        </motion.button>

        <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-[11px] sm:text-xs text-slate-500 font-medium mt-1" data-id="element-154">
          <span className="flex items-center gap-1" data-id="element-155">
            <LockIcon sx={{
            fontSize: 14
          }} data-id="element-156" />{' '}
            Pago seguro
          </span>
          <span className="flex items-center gap-1" data-id="element-157">
            <VerifiedUserIcon sx={{
            fontSize: 14
          }} data-id="element-158" />{' '}
            Garantía 7 días
          </span>
          <span className="flex items-center gap-1" data-id="element-159">
            <CreditCardIcon sx={{
            fontSize: 14
          }} data-id="element-160" />{' '}
            Mercado Pago
          </span>
        </div>
      </div>
    </section>;
}